import { FilterOption } from '../../../../../ui-components/lib/filter-dropdown/filter-dropdown.model';
import { TableFilterTab } from '../../../../../ui-components/lib/table/table.model';
import { RequestTypeEnum } from '../../../../common/enums/request-type';
import { Insight } from '../../../../common/models/insight.model';
import { ActionList } from '../../../../common/models/action-list.model';
import { EMPLOYEE_ROUTES } from '../../../../common/constants/employee.routing.constants';
import { ENDPOINTS } from '../../../../common/constants/endpoints.constants';
import { UserType } from '../../../../common/constants/user-types.constants';
import { RELATED_REQUESTS_COLUMN_HEADER } from '../../const';

export const IN_PROGRESS_INSIGHTS: Insight[] = [
  {
    label: 'my_organization_details_screen_in_progress_tab_first_insight_label',
    value: '0',
    iconName: 'task_view',
  },
  {
    label:
      'my_organization_details_screen_in_progress_tab_second_insight_label',
    value: '0',
    iconName: 'timer_start',
  },
];

export const IN_PROGRESS_VIEW_DETAILS_ACTION: ActionList = {
  key: 'view_details',
  hasIcon: true,
  label: 'view_details_action_item',
  hasDivider: false,
  labelCustomStyle: '',
  hasToggle: false,
  toggleValue: false,
  isLink: true,
};

export const IN_PROGRESS_FILTER_OPTIONS: FilterOption[] = [
  {
    key: 'workflowTypes',
    label: 'in_progress_filter_workflow_types_label',
    type: 'multi',
    apiUrl: ENDPOINTS.filters.workflowType,
    placeholder: 'in_progress_filter_workflow_types_placeholder',
  },
  {
    key: 'creationDate',
    label: 'in_progress_filter_creation_date_label',
    type: 'dateRange',
  },
  {
  key: 'projectIds',
  label: 'vendor_invoice_page_table_filter_option_product',
  type: 'multi',
  apiUrl: ENDPOINTS.Lookup.project,
  placeholder: 'vendor_invoice_page_table_filter_option_product_placeholder',
},
{
  key: 'resourceType',
  label: 'filter_resources_type_label',
  type: 'resourceType',
}
];

export const IN_PROGRESS_TABLE_FILTER_TABS: TableFilterTab[] = [
  {
    key: 'all',
    identifier: 'all',
    label: 'table_filter_tab_all_label',
    active: true,
    iconName: 'all',
  },
  {
    key: 'sla_exceeded',
    identifier: 'sla_exceeded',
    label: 'table_filter_tab_sla_exceeded_label',
    active: false,
    iconName: 'clock',
  },
];

export const IN_PROGRESS_DEFAULT_COLUMNS = [
  {
    header: '',
  },
  {
    header: 'in_progress_tab_id_header_title',
    showViewIcon: true,
    viewIconRouterLink: (row: any) => [
      `${EMPLOYEE_ROUTES.MY_ORGANIZATION.REQUEST}/${RequestTypeEnum.ACTION}/${row.step.flow.id.toString()}/${row.step.id.toString()}/${row.id.toString()}/${UserType.SUPER_MANAGER}`,
    ],
    isSortable: true,
    sortKey: 'request_id][type',
  },
  {
    header: 'in_progress_tab_request_name_header_title',
    isSortable: true,
    sortKey: 'workflow_type][type',
  },
  {
    header: 'in_progress_tab_creation_date_header_title',
    isSortable: true,
    sortKey: 'created_at][type',
  },
  {
    header: 'in_progress_tab_creator_header_title',
    isSortable: true,
    sortKey: 'creator][type',
  },
  {
    header: 'in_progress_tab_sla_header_title',
    isSortable: true,
    sortKey: 'due_date][type',
  },
  {
    header: 'in_progress_tab_request_subject_header_title',
    isSortable: true,
    sortKey: 'request_subject][type',
  },
  {
    header: 'in_progress_tab_related_project_header_title',
    isSortable: true,
    sortKey: 'related_project][type',
  },
  {
    header: 'in_progress_tab_current_step_header_title',
    isSortable: true,
    sortKey: 'current_position][type',
  },
  {
    header: 'in_progress_tab_assignee_header_title',
    isSortable: false,
    sortKey: 'assignee][type',
  },
  {
    header: RELATED_REQUESTS_COLUMN_HEADER,
    isSortable: false,
  },
  {
    header: '',
  },
];

export const IN_PROGRESS_ON_HOLD_COLUMNS = [
  {
    header: '',
  },
  {
    header: 'in_progress_tab_id_header_title',
    showViewIcon: true,
    viewIconRouterLink: (row: any) => [
      `${EMPLOYEE_ROUTES.MY_ORGANIZATION.REQUEST}/${RequestTypeEnum.ACTION}/${row.step.flow.id.toString()}/${row.step.id.toString()}/${row.id.toString()}/${UserType.SUPER_MANAGER}`,
    ],
    isSortable: true,
    sortKey: 'request_id][type',
  },
  {
    header: 'in_progress_tab_request_name_header_title',
    isSortable: true,
    sortKey: 'workflow_type][type',
  },
  {
    header: 'in_progress_tab_creation_date_header_title',
    isSortable: true,
    sortKey: 'created_at][type',
  },
  {
    header: 'in_progress_tab_creator_header_title',
    isSortable: true,
    sortKey: 'creator][type',
  },
  {
    header: 'in_progress_tab_sla_header_title',
    isSortable: true,
    sortKey: 'due_date][type',
  },
  {
    header: 'remaining_time_header_title',
    isSortable: false,
  },
  {
    header: 'in_progress_tab_request_subject_header_title',
    isSortable: true,
    sortKey: 'request_subject][type',
  },
  {
    header: 'in_progress_tab_related_project_header_title',
    isSortable: true,
    sortKey: 'related_project][type',
  },
  {
    header: 'in_progress_tab_current_step_header_title',
    isSortable: true,
    sortKey: 'current_position][type',
  },
  {
    header: 'in_progress_tab_assignee_header_title',
    isSortable: false,
    sortKey: 'assignee][type',
  },
  {
    header: RELATED_REQUESTS_COLUMN_HEADER,
    isSortable: false,
  },
  {
    header: '',
  },
];
